module.exports = __webpack_public_path__ + "static/11-IRAN-DOOGH.08c25805.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/calendar/images/beverages/11-IRAN-DOOGH.png
// module id = 605
// module chunks = 35783957827783